import React from 'react'
import { createRoot } from 'react-dom/client'
import { isInvestor } from '../../global/authentication/authentication-manager.js'
import FundFinder from './FundFinder.jsx'

function initListeners() {
  const openFundFinder = document.getElementById('open-mutual-fund-finder')
  const heroTextContainer = document.getElementById(
    'homepage-hero-text-container'
  )
  const mutualFundFinder = document.getElementById('mutual-fund-finder')
  const myFundsWatchList = document.getElementById('fund-watch-list')
  const istudioOpenFundFinder =
    document.getElementById('is-homepage-hero-subscribe-button') || null
  let root

  const handleClose = () => {
    openFundFinder?.classList.remove('u-hiddenVisually')
    heroTextContainer?.classList.remove('u-hidden')
    if (istudioOpenFundFinder) {
      istudioOpenFundFinder?.classList.remove('u-hiddenVisually')
    }

    if (isInvestor()) {
      myFundsWatchList?.classList.remove('u-hidden')
    }
    root.unmount()
  }

  openFundFinder.addEventListener('click', () => {
    openFundFinder.classList.add('u-hiddenVisually')

    if (!isInvestor()) {
      heroTextContainer.classList.add('u-hidden')
    }

    if (istudioOpenFundFinder) {
      istudioOpenFundFinder.classList.add('u-hiddenVisually')
    }

    if (isInvestor()) {
      myFundsWatchList.classList.add('u-hidden')
    }
    root = createRoot(mutualFundFinder)
    root.render(<FundFinder onClose={handleClose} />)
  })
}

class FundFinderInit extends HTMLElement {
  connectedCallback() {
    initListeners()
  }
}

customElements.define('fund-finder-init', FundFinderInit)
